import * as React from 'react'
import { ReactElement, useContext } from 'react'
import {
    Avatar,
    Button,
    Card,
    makeStyles,
    shorthands,
    Title1,
    tokens,
    Tooltip,
    TreeItemPersonaLayout,
} from '@fluentui/react-components'
import IdentityContext, { Identity, IdentityContextProps } from '../../context/IdentityContext'
import { Tree, TreeItem } from '@fluentui/react-components/unstable'
import { AddFilled, AddRegular, bundleIcon, SignOutFilled, SignOutRegular } from '@fluentui/react-icons'
import { AppAction } from '../../config/appConfig'
import { useTranslation } from 'react-i18next'
import { Image } from '@fluentui/react'

const useStyles = makeStyles({
    container: {
        display: 'grid',
        ...shorthands.gap(tokens.spacingVerticalM),
    },
    item: {
        paddingLeft: tokens.spacingHorizontalS,
    },
})

const Add = bundleIcon(AddFilled, AddRegular)
const SignOut = bundleIcon(SignOutFilled, SignOutRegular)

export default function SelectAccount(): ReactElement {
    const styles = useStyles()
    const { t: translate } = useTranslation()
    const { accounts } = useContext<IdentityContextProps>(IdentityContext)

    return (
        <div className={styles.container}>
            <Title1>{translate('authentication.account.select.title')} </Title1>
            <Card>
                <Tree aria-label="Accounts">
                    {accounts?.map(account => (
                        <TreeItem
                            key={account.username.toLowerCase()}
                            itemType="leaf"
                            onClick={() => Identity.current?.selectAccount(account.username)}
                        >
                            <TreeItemPersonaLayout
                                media={<Avatar />}
                                description={account.username.toLowerCase()}
                                className={styles.item}
                                aside={
                                    <Tooltip
                                        content={translate('authentication.account.select.logoff')}
                                        relationship="label"
                                        withArrow
                                    >
                                        <Button
                                            appearance="subtle"
                                            icon={<SignOut />}
                                            onClick={() => Identity.current?.logout(AppAction.LogOut, account.username)}
                                        />
                                    </Tooltip>
                                }
                            >
                                {account.name}
                            </TreeItemPersonaLayout>
                        </TreeItem>
                    ))}

                    <TreeItem itemType="leaf">
                        <TreeItemPersonaLayout
                            media={<Avatar icon={<Add />} />}
                            className={styles.item}
                            onClick={() => Identity.current?.login(true)}
                        >
                            {accounts?.length > 0
                                ? translate('authentication.account.select.other')
                                : translate('authentication.account.select.login')}
                        </TreeItemPersonaLayout>
                    </TreeItem>
                </Tree>
            </Card>
        </div>
    )
}
